<div id="wrapper">
  <div id="content-area">

   
                        
    <div class="categories-blocks" style="margin-bottom: 15px;"
      *ngIf="safilterslistparent!=undefined && safilterslistparent!=null && safilterslistparent.length>0 && showsafilter=='1' && showsafilter1=='1'">
      <div id="SaFilterid" class="left-menu" (click)="getsetopenview(setopenview)"><i class="icon fa fa-align-justify fa-fw"></i>
        {{SaFilterLable}}</div>
        
      <nav id="Filters" class="yamm megamenu-horizontal" role="navigation"
        [ngClass]="{'displynone': setopenview=='0','displyblock': setopenview=='1'}">
        <div class="select-category">
          <div class="single-cat" *ngFor="let tags of selecctedsatags">
            <label (click)="addremovesatags(tags)" class="cpointer"> {{tags | split :';'}} <span>x</span></label>
          </div>
          <div class="single-cat" *ngIf="selecctedsatags.length>0">
            <label (click)="removeallsatags()" class="cpointer" style="color:tomato;"> Clear All <span>x</span></label>
          </div>
        </div>
        <div class="single-categories" *ngFor="let menu of safilterslistparent;let l=index;">
          <label (click)="togglemenubar(l)"> {{menu.sa_lables}}</label>
          
                            
          <nav id="Filt{{l}}" class="yamm megamenu-horizontal" role="navigation">
            <div class="dropdown-list">
              <div class="single-list" *ngFor="let menu1 of menu.mitemlist">
                <div class="custom-checkbox" *ngIf="menu1.sa_lables==menu.sa_lables">
                  <input type="checkbox" id="{{menu1.code}}" [checked]="selecctedsatags.indexOf(menu1.code) > -1"
                    name="{{menu1.code}}" value="{{menu1.code}}" (change)="addremovesatags(menu1.code)" />
                  <label for="{{menu1.code}}">{{menu1.code_lables}} </label>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </nav>
    </div>
    <section class="unit-section" style="margin-bottom: 15px;"
      *ngIf="isShowCategory && webtype != '1' && (isaccesswithlogin=='1' || isLoggedIn)">
      <div class="left-menu-block">
        <div class="left-menu" (click)="Sliding()"><i class="icon fa fa-align-justify fa-fw"></i> {{categorylabel}}
        </div>
        <nav id="catMenu" class="yamm megamenu-horizontal" role="navigation"
          [ngClass]="{'displynone': setopenviewcategory=='0','displyblock': setopenviewcategory=='1'}">
          <ul class="menu">
            <li id="{{menu.tree_node}}" (mouseover)="GetforChilds(menu)"
              [ngClass]="{'arrow': checkmenuforchild(menu.name)==true}" *ngFor="let menu of getFilterByParent('')">
              <a id="{{menu.name}}" (click)="setmenuoff()" [routerLink]="['/categories',menu.tree_node.toLowerCase(),menu.name.toLowerCase()]"
                *ngIf="menu.parent_node == '' && menu.parent!=0">
                <label class="brandpro"> {{menu.name}}</label>
              </a>
              <a id="{{menu.name}}" (click)="settreenodeforsa(menu.tree_node)" [routerLink]="['/category',menu.tree_node.toLowerCase(),menu.name.toLowerCase()]"
                *ngIf="menu.parent_node == '' && menu.parent==0">
                <label class="brandpro"> {{menu.name}}</label>
              </a>
              <span class="arrow"></span>
              <ul class="submenu">
                <div *ngFor="let mm of getFilterByParent(menu.tree_node)">
                  <li (mouseover)="GetforChilds(mm)" *ngIf="mm.parent_node == menu.tree_node">
                    <a [routerLink]="['/categories',mm.tree_node.toLowerCase(),mm.name.toLowerCase()]" *ngIf="mm.parent!=0">{{mm.name}}</a>
                    <a (click)="settreenodeforsa(mm.tree_node)" [routerLink]="['/category',mm.tree_node.toLowerCase(),mm.name.toLowerCase()]" *ngIf="mm.parent==0">{{mm.name}}</a>
                    <ul class="submenu">
                      <div *ngFor="let nn of getFilterByParent(mm.tree_node)">
                        <li (mouseover)="GetforChilds(nn)" *ngIf="nn.parent_node == mm.tree_node">
                          <a [routerLink]="['/categories',nn.tree_node.toLowerCase(),nn.name.toLowerCase()]" *ngIf="nn.parent!=0">{{nn.name}}</a>
                          <a (click)="settreenodeforsa(nn.tree_node)" [routerLink]="['/category',nn.tree_node.toLowerCase(),nn.name.toLowerCase()]" *ngIf="nn.parent==0">{{nn.name}}</a>
                          <ul class="submenu">
                            <div *ngFor="let oo of getFilterByParent(nn.tree_node)">
                              <li (mouseover)="GetforChilds(oo)" *ngIf="oo.parent_node == nn.tree_node">
                                <a [routerLink]="['/categories',oo.tree_node.toLowerCase(),oo.name.toLowerCase()]" *ngIf="oo.parent!=0">{{oo.name}}</a>
                                <a (click)="settreenodeforsa(oo.tree_node)" [routerLink]="['/category',oo.tree_node.toLowerCase(),oo.name.toLowerCase()]" *ngIf="oo.parent==0">{{oo.name}}</a>
                              </li>
                            </div>
                          </ul>
                        </li>
                      </div>
                    </ul>
                  </li>
                </div>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </section>



    <div id="wrapper" style="margin-bottom: 15px;"
      *ngIf="!isShowCategory && webtype != '1' && (isaccesswithlogin=='1' || isLoggedIn)">
      <div id="content-area">
        <section class="unit-section">
          <div class="left-menu-block">
            <div class="left-menu" (click)="Sliding()"><i class="icon fa fa-align-justify fa-fw"></i> {{productlabel}}
            </div>
            <nav id="brandMenu" class="yamm megamenu-horizontal" role="navigation"
              [ngClass]="{'displynone': setopenviewcategory=='0','displyblock': setopenviewcategory=='1'}">
              <ul class="menu">
                <li id="{{menu.product_line}}" *ngFor="let menu of parentMenu">
                  <a id="{{menu.product_line}}" *ngIf="menu.maj_class == ''">
                    <label (click)="onBrandSelect(menu)" class="brandpro"> {{menu.PLDescr}}</label>
                  </a><span class="arrow"></span>
                  <a id="{{menu.product_line}}" *ngIf="menu.maj_class != ''">
                    <label (click)="onBrandSelectLanding(menu)" class="brandpro"> {{menu.MCDescr}}</label>
                  </a><span class="arrow"></span>
                  <ul class="submenu" *ngIf="checkmenuforchildbrand(menu.maj_class)==true">
                    <div *ngFor="let mm of childMenu">
                      <li *ngIf="mm.maj_class == menu.maj_class"><a
                          (click)="onBrandSelect(mm)">{{mm.PLDescr}}</a>

                      </li>
                    </div>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </section>
      </div>
    </div>


  </div>
</div>